<div class="involved-details">
  <div
    *ngIf="involved.value.id !== 0 || editMode"
    class="involved-info-container"
  >
    <form [formGroup]="involvedForm" *ngIf="editMode">
      <div class="form-group">
        <single-choice
          formControlName="involved"
          [completedUrl]="completionUrl"
          [topic]="'users'"
          [editMode]="editMode"
          [ticketId]="currentId"
          [icon]="'person'"
          (choiceEvent)="relaySingleChoice($event)"
          [labelOnDemand]="userIdLabelerByService"
          [choiceObserver]="userIdObserver"
        ></single-choice>
        <messages
          class="msg"
          [form]="involvedForm"
          [messagesObserver]="messages"
          fieldname="user"
        ></messages>
      </div>

      <div class="action-buttons" *ngIf="showSaveButton">
        <action-button
          class="btn-save"
          (actionEvent)="saveInvolved($event)"
          icon="save"
        ></action-button>
      </div>

      <messages
        class="msg"
        [form]="involvedForm"
        [messagesObserver]="messages"
        fieldname="involved"
        [showNonFieldKeys]="TRUE"
        [showFieldName]="TRUE"
        [showFieldKeys]="FALSE"
      ></messages>
    </form>
  </div>
</div>
